import ReferenceDetails from '../../../../brand/features/reference_index/controllers/ReferenceDetails';

const AdminReferencesDetails = () => {
  return <ReferenceDetails isAdmin />;
};
export default AdminReferencesDetails;
